import DVC_GRANDSTREAMHT802 from '../assets/images/devices/GrandstreamHT802.jpg';
import DVC_PolycomVVXVVX300 from '../assets/images/devices/PolycomVVX-VVX300.jpg';
import DVC_PolycomVVXVVX310 from '../assets/images/devices/PolycomVVX-VVX310.jpg';
import DVC_PolycomVVXVVX311 from '../assets/images/devices/PolycomVVX-VVX311.jpg';
import DVC_PolycomVVXVVX411 from '../assets/images/devices/PolycomVVX-VVX411.jpg';
import DVC_YealinkSIPT33G from '../assets/images/devices/YealinkSIP-T33G.jpg';
import DVC_YealinkSIPT48S from '../assets/images/devices/YealinkSIP-T48S.jpg';
import DVC_YealinkSIPT53 from '../assets/images/devices/YealinkSIP-T53.jpg';
import DVC_YealinkSIPT54 from '../assets/images/devices/YealinkSIP-T54.jpg';
import DVC_YealinkW60B from '../assets/images/devices/YealinkW60B.jpg';
import DVC_YealinkW70B from '../assets/images/devices/YealinkW70B.jpg';

import YeaLinkIcon from '../assets/icons/yea-link.svg';
import GrandsteamIcon from '../assets/icons/grandsteam-icon.svg';
import PolycomIcon from '../assets/icons/polycom-icon.svg';

import YealLinkFullIcon from '../assets/images/yealink.png';
import GrandsteamFullIcon from '../assets/images/grandstream.png';
import PolycomFullIcon from '../assets/images/polycom.png'
import PhoneDefaultIcon from '../assets/images/phone-default.png';
import DataphoneIcon from '../assets/images/dataphone-logo-sm.png';
import DataphoneFullIcon from '../assets/images/dataphone-full.png';

export const getDvcIcon = (userAgent: string) => {
    const normalizedAgent = userAgent.replace(/\s+/g, '');
    
    if (normalizedAgent.includes('GrandstreamHT802')) {
        return DVC_GRANDSTREAMHT802;
    } else if (normalizedAgent.includes('PolycomVVX-VVX_310')) {
        return DVC_PolycomVVXVVX310;
    } else if (normalizedAgent.includes('PolycomVVX-VVX_311')) {
        return DVC_PolycomVVXVVX311;
    } else if (normalizedAgent.includes('PolycomVVX-VVX_300')) {
        return DVC_PolycomVVXVVX300;
    } else if (normalizedAgent.includes('PolycomVVX-VVX_411')) {
        return DVC_PolycomVVXVVX411;
    } else if (normalizedAgent.includes('YealinkSIP-T33G')) {
        return DVC_YealinkSIPT33G;
    } else if (normalizedAgent.includes('YealinkSIP-T53')) {
        return DVC_YealinkSIPT53;
    } else if (normalizedAgent.includes('YealinkSIP-T48S')) {
        return DVC_YealinkSIPT48S;
    } else if (normalizedAgent.includes('YealinkSIP-T54')) {
        return DVC_YealinkSIPT54;
    } else if (normalizedAgent.includes('YealinkW60B')) {
        return DVC_YealinkW60B;
    } else if (normalizedAgent.includes('YealinkW70B')) {
        return DVC_YealinkW70B;
    }
    
    return null;
};

export const getDvcInfo = (userAgent: string) => {
    if (userAgent.startsWith('Yealink')) {
        return {
            icon: YeaLinkIcon,
            fullIcon: YealLinkFullIcon,
            name: 'Yealink'
        };
    } else if (userAgent.startsWith('Grandstream')) {
        return {
            icon: GrandsteamIcon,
            fullIcon: GrandsteamFullIcon,
            name: 'Grandstream'
        };
    } else if (userAgent.startsWith('Polycom')) {
        return {
            icon: PolycomIcon,
            fullIcon: PolycomFullIcon,
            name: 'Polycom'
        };
    } else if (userAgent.toLowerCase().includes('ringotel')) {
        return {
            icon: DataphoneIcon,
            fullIcon: DataphoneFullIcon,
            name: 'Dataphone'
        };
    } else {
        return {
            icon: PhoneDefaultIcon,
            fullIcon: PhoneDefaultIcon,
            name: 'Phone'
        };
    }
};